//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

/**
 * Read a cookie value from `document.cookie` by name.
 *
 * `document.cookie` exposes only `name=value` pairs (no Path/Domain), so when
 * two cookies share a name — a scoping misconfiguration — they can't be told
 * apart here.  This returns the first match and warns, rather than silently
 * returning nothing (which would surface downstream as an opaque CSRF failure).
 * Returns '' when the cookie is absent.
 */
export const readCookie = (name: string): string => {
  const values = document.cookie
    .split(';')
    .map((c) => c.trim())
    .filter((c) => c.startsWith(`${name}=`))
    .map((c) => c.slice(name.length + 1));
  if (values.length > 1)
    console.warn(`[readCookie] Multiple "${name}" cookies present; using the ` +
                 'first. Check the cookie\'s Path/Domain scoping.');
  return values[0] ?? '';
};
